"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
const react_1 = __importDefault(require("react"));
const Link_context_1 = require("./Link.context");
const Link_styles_1 = require("./Link.styles");
const LinkIcon_1 = require("./LinkIcon");
const LinkText_1 = require("./LinkText");
/**
 * @deprecated Please use <Ds.Link> instead
 */
const Link = (_a) => {
    var { id, href, children, theme = "light", openInNewTab = false, onClick, text, iconName } = _a, props = __rest(_a, ["id", "href", "children", "theme", "openInNewTab", "onClick", "text", "iconName"]);
    const isDarkTheme = theme === "dark";
    // prevents default link behaviour, calls the provided onClick function, and then manually navigates to the href provided
    const handleClick = (e) => {
        if (onClick) {
            e.preventDefault();
            onClick();
            openInNewTab
                ? window.open(href, "_blank", "noopener,noreferrer")
                : window.location.assign(href);
        }
    };
    return (react_1.default.createElement(Link_context_1.LinkProvider, { value: { theme, openInNewTab } },
        react_1.default.createElement(Link_styles_1.StyledLink, Object.assign({ id: id, href: href, target: openInNewTab ? "_blank" : undefined, rel: openInNewTab ? "noreferrer noopener" : undefined, "$isDarkTheme": isDarkTheme, onClick: handleClick }, props), text || iconName ? (react_1.default.createElement(react_1.default.Fragment, null,
            text,
            iconName || openInNewTab ? (react_1.default.createElement(LinkIcon_1.LinkIcon, { iconName: openInNewTab ? "OpenWindow" : iconName, rotation: iconName === "ArrowTail"
                    ? "right"
                    : undefined, theme: isDarkTheme ? "dark" : "light", openInNewTab: openInNewTab })) : null)) : (children))));
};
exports.Link = Link;
exports.Link.Icon = LinkIcon_1.LinkIcon;
exports.Link.Text = LinkText_1.LinkText;
//# sourceMappingURL=Link.js.map